// extracted by mini-css-extract-plugin
export default {"userAccount":"account_userAccount__1juGh"};